<template>
  <div class="item-wish">
    <a @click.prevent="addToWish" v-if="wishactive === 'False'" class="btn-wish" href="#">
      <i class="icon-wish"></i>
    </a>
    <a @click.prevent="removeWish" v-else class="btn-wish" href="#">
      <i class="icon-wish-active"></i>
    </a>
  </div>
</template>

<script>
import fireWishlistEvent from '@global/gtm/wishlist';
import axios from 'axios';

export default {
  data() {
    return {
      isRunning: false,
    };
  },
  props: ['wishactive', 'color', 'custommarketid', 'name', 'sellPrice'],
  methods: {
    addToWish: function () {
      if (this.isRunning) return;
      this.isRunning = true;
      axios
        .post(API_URL.FAVORITE, {
          CustomMarketID: this.custommarketid,
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.wishactive = 'True';

              fireWishlistEvent({
                color: this.color || undefined,
                id: this.custommarketid,
                name: this.name || undefined,
                sellPrice: this.sellPrice || undefined,
                size: this.size || undefined,
              });
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('Please login.');
          } else {
            AlertDialog.alert('The server is currently busy. Please try again later.');
          }
          this.isRunning = false;
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    removeWish: function () {
      if (this.isRunning) return;
      this.isRunning = true;

      axios
        .delete(API_URL.FAVORITE, {
          data: { CustomMarketID: this.custommarketid },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.wishactive = 'False';
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('Please login.');
          } else {
            AlertDialog.alert('The server is currently busy. Please try again later.');
          }
          this.isRunning = false;
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};
</script>
